import styled, { css} from "styled-components";
import { Bold } from "../../../../components/bold";
import { cssIf } from "../../../../utils/styledMixins";

export const CheckboxWrapper = styled.div(({ theme }) => css`
  position: relative;
  box-sizing: border-box;
  padding: 40px 20px 15px;
  background-color: ${theme.palette.grayscale.lighterGray};
  border-radius: 12.5px;

  ${Bold} {
    margin-bottom: 4px;
  }

  .checkbox-title {
    font-weight: ${theme.fonts.headingWeight};
  }

  &.has-error {
    background-color: ${theme.palette.input.error};

    &:before {
      display: block;
      visibility: visible;
      background-color: ${theme.palette.input.error};
      border-top: 5px solid ${theme.palette.input.error};
      ${cssIf(({ squareTop }) => !squareTop)`
        border-radius: 12.5px;
      `}
    }
  }

  &:before {
    content: "";
    box-sizing: border-box;
    background-color: ${theme.palette.grayscale.lighterGray};
    display: block;
    visibility: hidden;
    position: absolute;
    height: 12.5px;
    left: 2px;
    right: 2px;
    top: 0;
    ${cssIf(({ squareTop }) => squareTop)`
      visibility: visible;
      left: 0;
      right: 0;
    `};
  }

  @media only screen and (min-width: ${theme.breakpoints.XM}) {
    padding: 28px 40px 22px;
  }
`);